import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody, PaginatedBody } from '@/api/types';
import { getMultiSuggestApiUrl } from './multi-suggest.paths';
import {
  MultiSuggestStartBody,
  PaginatedSuggestionsListQueryParams,
  SuggestionCandidatesResponse,
  SuggestionReviewRequestBody,
  SuggestionSummaryType,
  SuggestionTypeResponse,
} from './multi-suggest.types';

const getSuggestionsCandidates = async (): Promise<SuggestionCandidatesResponse> => {
  const res = await http.get<ApiResponseBody<SuggestionCandidatesResponse>>(
    getMultiSuggestApiUrl.suggestionsCandidates(),
  );
  return res.data.data;
};

const getSuggestionsList = async (
  params: PaginatedSuggestionsListQueryParams,
): Promise<PaginatedBody<SuggestionSummaryType>> => {
  const res = await http.get<PaginatedApiResponseBody<SuggestionSummaryType>>(getMultiSuggestApiUrl.suggestion(), {
    params,
  });
  return res.data.data;
};

const startSuggestion = async (body: MultiSuggestStartBody) => {
  const res = await http.post<ApiResponseBody<SuggestionTypeResponse>>(getMultiSuggestApiUrl.suggestion(), body);
  return res.data.data;
};

const getSuggestionById = async (id: string): Promise<SuggestionTypeResponse> => {
  const res = await http.get<ApiResponseBody<SuggestionTypeResponse>>(getMultiSuggestApiUrl.suggestionById(id));
  return res.data.data;
};

const createSuggestionReview = async (
  id: string,
  body: SuggestionReviewRequestBody,
): Promise<SuggestionTypeResponse> => {
  const res = await http.post<ApiResponseBody<SuggestionTypeResponse>>(
    getMultiSuggestApiUrl.suggestionReviews(id),
    body,
  );
  return res.data.data;
};

const updateSuggestionReviewById = async (
  id: string,
  reviewId: string,
  body: SuggestionReviewRequestBody,
): Promise<SuggestionTypeResponse> => {
  const res = await http.patch<ApiResponseBody<SuggestionTypeResponse>>(
    getMultiSuggestApiUrl.suggestionReviewById(id, reviewId),
    body,
  );
  return res.data.data;
};

export const multiSuggestApiFetcher = {
  getSuggestionsCandidates,
  getSuggestionsList,
  startSuggestion,
  getSuggestionById,
  createSuggestionReview,
  updateSuggestionReviewById,
};
